module.exports = __webpack_public_path__ + "img/vignettes-asso_0009_zup-de-co.bb2998ed.jpg";